<template>
    <div class="content">
        <div class="modal" v-if="isSent">
            <div class="success" >
                <img src="@/assets/images/email.webp" alt="" />
                <h1 class="title">Email Sent!</h1>
                <p>
                    Thank you for reaching out!!! I’ll get back to you as soon
                    as possible
                </p>
            </div>
        </div>
        <div class="intro">
            <h2>This is my Personal Portfolio</h2>
            <h1>I’M<br />RIO MARTIN GOLIMLIM</h1>
            <div class="skills">
                <p>&lt;Back-End&gt;</p>
                <span class="circle"></span>
                <p class="mid">UX/UI Designer</p>
                <span class="circle"></span>
                <p>&lt;Front-End&gt;</p>
            </div>
        </div>
        <div class="hire">
            <div class="content-hire">
                <h1>HIRE ME!</h1>
                <div class="forms">
                    <input
                        type="text"
                        placeholder="Please Enter your Email"
                        v-model="email"
                        :class="{
                            error: (isEmailClicked && !email) || !isEmail,
                            mb: (!isEmailClicked && email) || isEmail,
                        }"
                        @click="isEmailClicked = true"
                    />
                    <p v-if="!isEmail && email" class="error_p">
                        Please Enter a valid email
                    </p>
                    <p v-if="!email && isEmailClicked" class="error_p">
                        Email is required
                    </p>
                    <input
                        type="text"
                        placeholder="Please Enter your Name"
                        v-model="name"
                        class="name"
                        :class="{
                            error: isNameClicked && !name,
                            mb: !isNameClicked || name,
                        }"
                        @click="isNameClicked = true"
                    />
                    <p v-if="!name && isNameClicked" class="error_p">
                        Name is required
                    </p>
                    <textarea
                        name=""
                        id=""
                        cols="30"
                        rows="10"
                        placeholder="Write your Message here..."
                        v-model="msg"
                        :class="{
                            error: isMsgClicked && !msg,
                        }"
                        @click="isMsgClicked = true"
                    ></textarea>
                    <p v-if="!msg && isMsgClicked" class="error_p">
                        Message is required
                    </p>
                    <div
                        class="btn"
                        @click.prevent="submit"
                        :class="{ isDisable: !isDisable }"
                    >
                        <div class="lds-ripple" v-if="loader">
                            <div></div>
                            <div></div>
                        </div>
                        <div v-if="!loader">Email Me!</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import emailjs from "@emailjs/browser";
export default {
    setup() {
        const name = ref("");
        const email = ref("");
        const msg = ref("");
        const isEmail = ref(true);
        const isEmailClicked = ref(false);
        const isNameClicked = ref(false);
        const isMsgClicked = ref(false);
        const isSent = ref(false);
        const loader = ref(false);
        const submit = () => {
            if (!isDisable.value) return;
            loader.value = true;
            emailjs
                .send(
                    "service_btie3sd",
                    "template_4ssaff7",
                    {
                        from_name: name.value,
                        message: msg.value,
                        from_email: email.value,
                    },
                    "7vM6ZDyzJHRoRWeH3"
                )
                .then((res) => {
                    if (res.status == 200 && res.text == "OK") {
                        isSent.value = true;
                        loader.value = false;
                        console.log("SUCCESS!", res.status, res.text);
                        setTimeout(() => {
                            isSent.value = false;
                        }, 4000);
                        name.value = "";
                        msg.value = "";
                        email.value = "";
                        isEmailClicked.value = false;
                        isMsgClicked.value = false;
                        isNameClicked.value = false;
                        isEmail.value = true;
                    } else {
                        console.log("error!", res);
                    }
                });
        };
        const validateEmail = (email) => {
            if (/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                isEmail.value = true;
            } else {
                isEmail.value = false;
            }
        };
        watch(email, (new_value) => {
            if (!new_value) return;
            validateEmail(new_value);
        });
        const isDisable = computed(() => {
            if (isEmail.value && name.value && msg.value) {
                return true;
            }
            return false;
        });

        return {
            name,
            email,
            msg,
            submit,
            isEmail,
            isEmailClicked,
            isMsgClicked,
            isNameClicked,
            isDisable,
            isSent,
            loader,
        };
    },
};
</script>

<style lang="scss" scoped>
.content {
    height: 75vh;
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 9999;

        .success {
            width: 300px;
            height: 145px;
            background: #fff;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 10px;
            border-bottom: 3px solid #16a085;
            color: #04293a;
            .title {
                color: #04293a;
                font-size: 20px;
            }
            p {
                font-size: 15px;
                text-align: center;
            }
        }
    }
    .intro {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
        margin-bottom: 5vh;
        height: 30%;
        h2 {
            color: #fff;
            font-weight: lighter;
            font-size: 20px;
        }
        h1 {
            color: #eacaa0;
            font-size: 30px;
            text-align: center;
        }
        .skills {
            display: flex;
            font-size: 15px;
            align-items: center;
            color: #fff;
            gap: 12px;
            font-weight: lighter;
            .circle {
                width: 8px;
                height: 8px;
                background: #ecb365;
                border-radius: 20px;
            }
        }
    }
    .hire {
        width: 100vw;
        display: flex;
        height: 70%;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        .content-hire {
            padding-bottom: 20px;
            background: #064663;
            width: 95vw;
            border-top-left-radius: 80px;
            border-top-right-radius: 80px;
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            h1 {
                color: #ecb365;
                font-size: 30px;
                margin: 25px 0;
            }
            .forms {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .error_p {
                    color: #c44d56;
                    font-size: 15px;
                    font-weight: bolder;
                    margin: 5px 0;
                }

                input {
                    border: 2px solid #ecb365;
                    width: 64vw;
                    height: 4.2vh;
                    background: none;
                    border-radius: 10px;
                    padding: 0 10px;
                    color: #fff;
                    &::placeholder {
                        font-family: "Poppins", sans-serif;
                        color: #fff;
                        font-size: 15px;
                        font-weight: lighter;
                    }

                    &:focus {
                        outline: none;
                    }
                }
                .name {
                }
                .mb {
                    margin-bottom: 18px;
                }
                .mt {
                    margin-top: 18px;
                }
                .error {
                    border-color: #b92b27;
                    margin: 0;
                }
                textarea {
                    width: 64vw;
                    height: 8vh;
                    border-radius: 10px;
                    background: none;
                    border: 2px solid #ecb365;
                    padding: 10px;
                    color: #fff;
                    font-family: "Poppins", sans-serif;
                    &::placeholder {
                        font-family: "Poppins", sans-serif;
                        color: #fff;
                        font-size: 15px;
                        font-weight: lighter;
                    }
                    &:focus {
                        outline: none;
                    }
                }
                .btn {
                    width: 64vw;
                    height: 4.2vh;
                    background: none;
                    border-radius: 10px;
                    padding: 0 10px;
                    margin-top: 18px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #04293a;
                    background: #ecb365;
                }
                .isDisable {
                    background: #4b4c4e;
                    cursor: not-allowed;
                }
            }
        }
    }
}
</style>
